import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import {OktaService} from './okta.service';
import {environment} from '../../../environments/environment';
import {IconElement, ImageElement} from './catalog.service';

export interface PartnerElement {
    'partnerID': number,
    'name': string,
    'item': number,
    'statusID': number,
    'published': boolean,
    'revisionDate': string,
    'tagline': string,
    'problem': string,
    'approach': string,
    'features': string,
    'images': ImageElement[],
    'icons': IconElement,
    'techDescription': string,
    'previousNames': string[],
    'shortDescription': string,
    'subtitle': string,
    'solutionArea': number
}

@Injectable()
export class PartnerService {
    partnerList: BehaviorSubject<PartnerElement[] | null> = new BehaviorSubject<PartnerElement[] | null>(null);
    loadFailed = false;

    constructor(private http: HttpClient, private oktaService: OktaService) {}

    get partnersUpdated(): Observable<PartnerElement[] | null> {
        return this.partnerList.asObservable();
    }

    refresh() {
        this.loadFailed = false;

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        this.http.get<any>(environment.azure.url + '/admin.partners', options).subscribe({
            next: data => {
                this.partnerList.next(data);
                this.loadFailed = false;
            },
            error: msg => {
                this.loadFailed = true;
                this.partnerList.next(null);
                console.log(msg);
            }
        });
    }

    detail(partnerID: number): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.get<any>(environment.azure.url + '/admin.partners/' + partnerID, options);
    }

    add(target: PartnerElement): Observable<any> {
        // Write target to database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        return this.http.post<any>(environment.azure.url + '/admin.partners.add', {
            name: target.name,
            item: target.item,
            statusID: target.statusID,
            published: target.published,
            revisionDate: target.revisionDate,
            tagline: target.tagline,
            problem: target.problem,
            approach: target.approach,
            features: target.features,
            images: JSON.stringify(target.images),
            icons: JSON.stringify(target.icons),
            techDescription: target.techDescription,
            previousNames: JSON.stringify(target.previousNames),
            shortDescription: target.shortDescription,
            subtitle: target.subtitle,
            solutionArea: target.solutionArea
        }, options)
    }

    update(target: PartnerElement): Observable<any> {
        // Update target in database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        return this.http.post<any>(environment.azure.url + '/admin.partners.update', {
            partnerID: target.partnerID,
            name: target.name,
            item: target.item,
            statusID: target.statusID,
            published: target.published,
            revisionDate: target.revisionDate,
            tagline: target.tagline,
            problem: target.problem,
            approach: target.approach,
            features: target.features,
            images: JSON.stringify(target.images),
            icons: JSON.stringify(target.icons),
            techDescription: target.techDescription,
            previousNames: JSON.stringify(target.previousNames),
            shortDescription: target.shortDescription,
            subtitle: target.subtitle,
            solutionArea: target.solutionArea
        }, options)
    }
}
